import React from 'react';
import { Button } from '@components';
import { motion } from 'framer-motion';

const Section = (props) => {
  const { title = '', description = '', children = null, onClick = () => {} } = props;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}>
      <div className="px-4 sm:px-6 lg:px-8 mt-4 sm:mt-6 lg:mt-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h1>
            <p className="mt-2 text-sm text-gray-700 dark:text-gray-200">{description}</p>
          </div>
          <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <Button
              className="ml-5 inline-flex gap-0.5 justify-center overflow-hidden text-sm font-medium transition rounded-full  dark:bg-gray-900 py-1 px-3 focus:ring-teal-400/20 bg-gray-700 hover:bg-gray-900 dark:bg-teal-400/10 dark:text-teal-400 dark:ring-1 dark:ring-inset dark:ring-teal-400/20 dark:hover:bg-teal-400/10 dark:hover:text-teal-300 dark:hover:ring-teal-300"
              onClick={() => onClick()}>
              Ajouter {title}
            </Button>
          </div>
        </div>
        {children}
      </div>
    </motion.div>
  );
};

export default Section;
